import { PageTitle } from "Components/Titles";
import { Container } from "semantic-ui-react";
import { UpdateUnit } from "Features/Unit";
import { useTranslation } from "react-i18next";

function EditUnit () {

    const { t } = useTranslation();

    return (
        <Container className="page">
            <PageTitle title={t("pages.editUnit")} />
            <UpdateUnit />
        </Container>
    );
}

export default EditUnit;